import styled from 'styled-components'

export const Divider = styled.div`
  background: ${({ theme }) => theme.color.lightGrey};
  height: 1px;
  align-self: stretch;
`
